<div #scrollTarget></div>
<div class="container-fluid mt-4">
  <h4 class="mb-3"><i class="fi fi-rr-newspaper"></i> სტატიები <span *ngIf="currentLang == 'en'">(EN)</span></h4>
  
  <div class="row mb-3">
    <div class="col-md-3">
      <!-- Dropdown list ტიპის მენიუებისთვის -->
    <select
  class="form-select"
  [(ngModel)]="selectedItem"
  (ngModelChange)="onMenuChange($event)"
>
  <option *ngFor="let itm of selectedItems" [ngValue]="itm.menu_page">
    {{ itm?.menu?.title || itm?.title || itm?.menu_page }}
  </option>
</select>
    </div>
    <div class="col-md-3">
      <button class="btn btn-primary" (click)="openPost()">დამატება</button>
    </div>
    <div class="col-md-4">
      <input 
        type="text" 
        [(ngModel)]="search" 
        class="form-control" 
        placeholder="ძიება..." 
        (ngModelChange)="getPageByItems()" />
    </div>
  </div>

  <app-spinner [loading]="loaddata" text="იტვირთება..."></app-spinner>

  <div class="table-responsive" *ngIf="data?.items?.length">
    <table class="table table-bordered table-hover">
      <thead>
        <tr>
          <th>#</th>
          <th>სურათი</th>
          <th (click)="sortData('title')" style="cursor:pointer">სათაური
            <span *ngIf="sortColumn === 'title'">{{ sortDirection === 'asc' ? '↑' : '↓' }}</span>
          </th>
          <th (click)="sortData('postdate')" style="cursor:pointer">დამატების თარიღი
            <span *ngIf="sortColumn === 'postdate'">{{ sortDirection === 'asc' ? '↑' : '↓' }}</span>
          </th>
          <!-- Visibility column removed -->
          <th>ქმედებები</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data.items; let i = index">
          <td>{{ (page - 1) * perPage + i + 1 }}</td>
          <td>
           <img
              *ngIf="item.menu_page == 159 || hasDisplayImage(item)"
              [src]="item.menu_page == 159 ? 'https://api.sca.ge/storage/res/images/images/logo-axali.jpg' : getFullImageUrl(getMainImageUrl(item))"
              class="square-img"
            />
          </td>
          <td class="truncate-text">{{ item.title }}</td>
          <td>{{ item.date || item.date | date:'dd MMM yyyy, HH:mm' }}</td>
          <!-- Visibility column removed -->
          <td>
            <div class="d-flex">
              <a class="btn btn-sm border rounded mx-2" href="https://sca.ge/list/{{item.menu_page}}/{{item.id}}" target="_blank">
                <i class="fi fi-rr-link-alt"></i>
              </a>

                            <button
                class="btn btn-sm border rounded mx-2"
                (click)="togglePin(item)"
                [disabled]="item.__togglingPin"
                [title]="item.pin == 1 ? 'Pin მოხსნა' : 'Pin ჩართვა'">
                <span *ngIf="item.__togglingPin" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <i *ngIf="!item.__togglingPin && item.pin == 1" class="fi fi-rr-thumbtack text-warning"></i>
                <i *ngIf="!item.__togglingPin && item.pin != 1" class="fi fi-rr-thumbtack"></i>
              </button>


              <button
                class="btn btn-sm border rounded mx-2"
                (click)="toggleVisible(item)"
                [disabled]="item.__togglingVisible"
                [title]="item.visible == 1 ? 'გამორთვა' : 'ჩართვა'">
                <span *ngIf="item.__togglingVisible" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <i *ngIf="!item.__togglingVisible && item.visible == 1" class="fi fi-rr-eye text-success"></i>
                <i *ngIf="!item.__togglingVisible && item.visible == 0" class="fi fi-rr-eye-crossed text-danger"></i>
              </button>

              <button class="btn btn-sm border rounded mx-2" (click)="edit(item)">
                <i class="fi fi-rr-pencil"></i>
              </button>


              <button
                class="btn btn-sm border rounded mx-2"
                (click)="delete(item)"
                title="წაშლა">
                <i class="fi fi-rr-trash text-danger"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Pagination -->
    <nav *ngIf="data?.pagination?.last_page > 1" class="mt-3">
      <ul class="pagination justify-content-center">
        <li class="page-item" [class.disabled]="page === 1">
          <button class="page-link" (click)="changePage(page - 1)" [disabled]="page === 1">&laquo;</button>
        </li>

        <li class="page-item" [class.active]="page === 1">
          <button class="page-link" (click)="changePage(1)">1</button>
        </li>

        <li class="page-item disabled" *ngIf="page > 4">
          <span class="page-link">...</span>
        </li>

        <ng-container *ngFor="let i of [].constructor(data.pagination.last_page); let idx = index">
          <ng-container *ngIf="idx + 1 > 1 && idx + 1 < data.pagination.last_page &&
                              idx + 1 >= page - 1 && idx + 1 <= page + 1">
            <li class="page-item" [class.active]="page === idx + 1">
              <button class="page-link" (click)="changePage(idx + 1)">{{ idx + 1 }}</button>
            </li>
          </ng-container>
        </ng-container>

        <li class="page-item disabled" *ngIf="page < data.pagination.last_page - 3">
          <span class="page-link">...</span>
        </li>

        <li class="page-item" [class.active]="page === data.pagination.last_page">
          <button class="page-link" (click)="changePage(data.pagination.last_page)">
            {{ data.pagination.last_page }}
          </button>
        </li>

        <li class="page-item" [class.disabled]="page === data.pagination.last_page">
          <button class="page-link" (click)="changePage(page + 1)" [disabled]="page === data.pagination.last_page">&raquo;</button>
        </li>
      </ul>
    </nav>
  </div>
</div>
